import { CloseIcon } from '../toast-notification/icons'

export function ModalHeader({
    onClose,
    title,
}: {
    onClose: () => void
    title: string
}): JSX.Element {
    return (
        <div className='w-full h-max border-b border-gray5 flex flex-row items-center justify-end relative py-2 z-20'>
            <p className='p-0 m-0 w-full absolute text-center text-white'>
                {title}
            </p>
            <button
                className='mr-4 text-white cursor-pointer font-semibold text-xl z-20'
                onClick={onClose}>
                <CloseIcon />
            </button>
        </div>
    )
}
